export default __webpack_public_path__ + "static/media/024-jet.f47bb460.png";